<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="单位基本信息" :sub-title="subTitle" @back="onBack">
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类型">
                                            <a-input ref="dwlx" v-model="editData.dwlx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类别">
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="资信等级">
                                            <a-input ref="zxdj" v-model="editData.zxdj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域编号">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册地址">
                                            <a-input ref="zcdz" v-model="editData.zcdz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公地址">
                                            <a-input ref="bgdz" v-model="editData.bgdz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="邮政编码">
                                            <a-input ref="yzbm" v-model="editData.yzbm" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="行业分类">
                                            <a-input ref="hyfl" v-model="editData.hyfl" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册资金(万元)">
                                            <a-input-number ref="zczj" v-model="editData.zczj" style="width:100%" :precision="6" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人代表">
                                            <a-input ref="frdb" v-model="editData.frdb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人固定电话">
                                            <a-input ref="frgddh" v-model="editData.frgddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人移动电话">
                                            <a-input ref="fryddh" v-model="editData.fryddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="固定电话">
                                            <a-input ref="gddh" v-model="editData.gddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="移动电话">
                                            <a-input ref="yddh" v-model="editData.yddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="传真">
                                            <a-input ref="cz" v-model="editData.cz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="电子邮箱">
                                            <a-input ref="dzyx" v-model="editData.dzyx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="信息/通讯员">
                                            <a-input ref="xxyxm" v-model="editData.xxyxm" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="信息/通讯员电话">
                                            <a-input ref="xxydh" v-model="editData.xxydh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="网址">
                                            <a-input ref="wz" v-model="editData.wz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位性质">
                                            <a-input ref="dwxz" v-model="editData.dwxz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职工总人数">
                                            <a-input-number ref="zgzrs" v-model="editData.zgzrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专业技术人员数">
                                            <a-input-number ref="zyjsrs" v-model="editData.zyjsrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专职从事工程咨询人数">
                                            <a-input-number ref="zzcszxrs" v-model="editData.zzcszxrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册咨询师人数">
                                            <a-input-number ref="zczxsrs" v-model="editData.zczxsrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="高级职称人数">
                                            <a-input-number ref="gjzcrs" v-model="editData.gjzcrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="中级职称人数">
                                            <a-input-number ref="zjzcrs" v-model="editData.zjzcrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="初级职称人数">
                                            <a-input-number ref="cjzcrs" v-model="editData.cjzcrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="博士人数">
                                            <a-input-number ref="bsrs" v-model="editData.bsrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="硕士人数">
                                            <a-input-number ref="ssrs" v-model="editData.ssrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="本科人数">
                                            <a-input-number ref="bkrs" v-model="editData.bkrs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公面积(平方)">
                                            <a-input-number ref="bgmj" v-model="editData.bgmj" style="width:100%" :precision="2" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="其中自有面积(平方)">
                                            <a-input-number ref="zymj" v-model="editData.zymj" style="width:100%" :precision="2" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="计算机台数">
                                            <a-input-number ref="jsjts" v-model="editData.jsjts" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="质量体系认证">
                                            <a-input ref="zltxrz" v-model="editData.zltxrz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证日期">
                                            <a-input ref="rzrq" v-model="editData.rzrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证机构">
                                            <a-input ref="rzjg" v-model="editData.rzjg" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="会费缴纳标准(元/年)">
                                            <a-input-number ref="hfjnbz" v-model="editData.hfjnbz" style="width:100%" :precision="2" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="理事代表">
                                            <a-input ref="lsdb" v-model="editData.lsdb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="理事代表联系方式">
                                            <a-input ref="lsdblxfs" v-model="editData.lsdblxfs" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="纳税人识别号">
                                            <a-input ref="nsrsbh" v-model="editData.nsrsbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="用户名">
                                            <a-input ref="yhm" v-model="editData.yhm" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="单位简介" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea v-model="editData.dwjj" :rows="3" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea v-model="editData.bz" :rows="3" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 其他资质证书明细表格 -->
                        <FGCollapsiblePanel title="其他资质证书">
                            <vxe-table
                                ref="QTZZZSitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataQTZZZS"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="zsmc" title="证书名称" width="200" sortable></vxe-table-column>
                                <vxe-table-column field="zsbh" title="证书编号" width="150"></vxe-table-column>
                                <vxe-table-column field="zymc" title="专业名称" min-width="150"></vxe-table-column>
                                <vxe-table-column field="zzdj" title="资质等级" width="120"></vxe-table-column>
                                <vxe-table-column field="zsrq" title="证书日期" width="120">
                                    <template v-slot="{ row }">
                                        <span> {{ $FG_util.formatDate(row.zsrq, "YYYY-MM-DD") }} </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zzyxq" title="资质有效期(年)" width="150"></vxe-table-column>
                                <vxe-table-column field="zsdqrq" title="证书到期日期" width="150">
                                    <template v-slot="{ row }">
                                        <span> {{ $FG_util.formatDate(row.zsdqrq, "YYYY-MM-DD") }} </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="bz" title="备注" min-width="200"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 单位通讯员明细表格 -->
                        <FGCollapsiblePanel title="单位通讯员">
                            <vxe-table
                                ref="LXRitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataLXR"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="lxr" title="通讯员姓名" min-width="150" sortable></vxe-table-column>
                                <vxe-table-column field="bmmc" title="部门" width="150"></vxe-table-column>
                                <vxe-table-column field="zw" title="职务" width="120"></vxe-table-column>
                                <vxe-table-column field="qq" title="QQ" width="150"></vxe-table-column>
                                <vxe-table-column field="gddh" title="固定电话" width="120"></vxe-table-column>
                                <vxe-table-column field="yddh" title="移动电话" width="120"></vxe-table-column>
                                <vxe-table-column field="dzyx" title="电子邮箱" width="120"></vxe-table-column>
                                <vxe-table-column field="txdz" title="通讯地址" width="150"></vxe-table-column>
                                <vxe-table-column field="zsbh" title="证书编号" width="150"></vxe-table-column>
                                <vxe-table-column field="bz" title="备注" min-width="200"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- <FGCollapsiblePanel title="相关附件">
                            <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="营业执照扫描件" required>
                                            <UploadButton field="yyzz" :state="2" :attachCfg.sync="attachCfg_Edit" />
                                            <a-tooltip style="margin-left: 10px;color: red">
                                                <template slot="title">
                                                    5M以内,文件需要命名为【营业执照】
                                                </template>
                                                <a-icon type="exclamation-circle" />
                                            </a-tooltip>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册申请表扫描件" required>
                                            <UploadButton field="zcsqb" :state="2" :attachCfg.sync="attachCfg_Edit" />
                                            <a-tooltip style="margin-left: 10px;color: red">
                                                <template slot="title">
                                                    申请表请申请单位自行编写，无固定格式；须加盖单位有效公章”，“5M以内,文件需要命名为【注册申请表】
                                                </template>
                                                <a-icon type="exclamation-circle" />
                                            </a-tooltip>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </a-form>
                        </FGCollapsiblePanel> -->
                    </a-spin>
                    <!-- 操作日志 -->
                </a-layout-content>
                <!-- <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :isnew="isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider> -->
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "DwxxForm",
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            //资质证书及服务范围
            editItemDataZZZS: [],
            editItemDataZZZSLoading: false,
            //其它资质证书
            editItemDataQTZZZS: [],
            editItemDataQTZZZSLoading: false,
            //分支机构
            editItemDataFZJG: [],
            editItemDataFZJGLoading: false,
            //项目成果获奖情况
            editItemDataXMCG: [],
            editItemDataXMCGLoading: false,
            //单位通讯员
            editItemDataLXR: [],
            editItemDataLXRLoading: false,
            isnew: true,
            isShowIcon: true,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: ""
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "查看";
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg() {
            return {
                fktable: "DW_BGSQB",
                fkvalue: this.dataId,
                attachsource: "DW5001"
            };
        },
        attachCfg_Edit() {
            return {
                fktable: "DW_BGSQB",
                fkvalue: this.editData.id,
                attachsource: "DW5001"
            };
        }
    },
    mounted() {
        let user = this.getUserInfo;
        this.loadData(user);
    },
    activated() {
        // this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData(user) {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwxxgl/selectById",
                    {
                        id: user.companyInfo.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.loadItemDataQTZZZS(user.companyInfo.id);
                            this.loadItemDataLXR(user.companyInfo.id);
                        }
                    }
                });
        },
        loadItemDataQTZZZS(id) {
            this.editItemDataQTZZZS = [];
            this.editItemDataQTZZZSLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwxxgl/listItemQTZZZS",
                    {
                        dwid: id,
                        sort: {
                            field: "zsbh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataQTZZZSLoading = false;
                    if (success) {
                        this.editItemDataQTZZZS = data.data;
                    }
                });
        },
        // 加载明细表数据
        loadItemDataLXR(id) {
            this.editItemDataLXR = [];
            this.editItemDataLXRLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwxxgl/listItemLXR",
                    {
                        dwid: id,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLXRLoading = false;
                    if (success) {
                        this.editItemDataLXR = data.data;
                    }
                });
        },
        onBack() {
            this.$router.push({ path: "/main/home" });
        }
    }
};
</script>
<style lang="scss" scoped></style>
